import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCrop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"crop"} maskId="square-filled-radius-0-stroke-1-IconCrop"><path d="M17 7H7V17H17V7Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M6 2V5H19V18H22V19H19V22H18V19H5V6H2V5H5V2H6ZM6 18V6H18V18H6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCrop;
